import React, {useState, useRef, useEffect} from "react"
import PropTypes from "prop-types"
import get from "lodash/get"
import omitBy from "lodash/omitBy"
import isNil from "lodash/isNil"
import className from "classnames"
import includes from "lodash/includes"
import Cookies from "js-cookie"
import MobileDetect from "mobile-detect"
import validator from "validator"

import {axios, tt} from "@lib/helpers"

import {NoNameFunctionReturnVoid} from "types/common"
import {formDataType} from "types/pointPurchase"

import DefaultCardLink from "components/creditCard/DefaultCardLink"
import {loadPayments} from "@payjp/payments-js"

type withProductType = {
  title: string
  context: string
}
type defaultPaymentMethodCardType = {
  brand: string
  last4: string
  img: string
}
type User = {
  email: string
  phone_number: string
}
type AppGMOBookingsReserveProps = {
  data: {
    api_key: string
    spot_token: string
    booking_token: string
    purchasable: {
      bookings_path: string
      spot_token: string
      btn_name: string
    }
    user_has_points: number
    required_point: number
    point_rate: number
    section: Map<string, string>
    dictionary: Map<string, string>
    t: {
      current: string
      point_purchase_form: string
      shipping: string
      payment_form: string
    }
    btn_name: string
    proceed_path: string
    point_purchases_path: string
    return_url: string
    default_payment_method_card: defaultPaymentMethodCardType
    payments_path: string
    create_payment_flow_path: string
    validate_before_create_bookings_path: string
    with_product: Array<withProductType>
    package_title: string
    agency_setting: any
    allow_coupon: boolean
    user: User
  }
}

const AppPayjpBookingsReserve = ({data}: AppGMOBookingsReserveProps) => {
  const {
    api_key,
    spot_token,
    booking_token,
    purchasable,
    user_has_points,
    required_point,
    point_rate,
    section,
    dictionary,
    t,
    btn_name,
    proceed_path,
    point_purchases_path,
    return_url,
    default_payment_method_card,
    payments_path,
    create_payment_flow_path,
    validate_before_create_bookings_path,
    with_product,
    package_title,
    agency_setting,
    allow_coupon,
    user,
  } = data

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [hasErrors, setHasErrors] = useState<boolean>(false)
  const [supportBrowserPayment, setSupportBrowserPayment] =
    useState<boolean>(false)
  const [isMobileChrome, setIsMobileChrome] = useState<boolean>(false)

  const [couponDiscount, setCouponDiscount] = useState<number | null>(null)
  const [couponCode, setCouponCode] = useState<string>("")
  const [couponIsLoading, setCouponIsLoading] = useState<boolean>(false)
  const [couponErrors, setCouponErrors] = useState<string>(null)
  const [pointDiff, setPointDiff] = useState<number>(
    user_has_points - required_point
  )
  const [payments, setPayments] = useState<any>(null)
  const [widgets, setWidgets] = useState<any>(null)
  const [clientSecret, setClientSecret] = useState<string>("")
  const [paymentFlowId, setPaymentFlowId] = useState<string>("")
  const [message, setMessage] = useState<string>("")
  const mobileDetect = new MobileDetect(window.navigator.userAgent)
  const paypalRef = React.useRef(null)
  const paymentFormRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    // @ts-ignore
    if (typeof paypal != "undefined" && paypal) {
      if (window.paypalButton) window.paypalButton.close()
      // @ts-ignore
      window.paypalButton = paypal.Buttons({
        style: {
          height: 55,
        },
        onClick: async (data, actions) => {
          return axios
            .get(validate_before_create_bookings_path, {
              spot_token: spot_token,
              booking_token: booking_token,
            })
            .catch((e) => {
              window.setTimeout(() => {
                window.location.reload()
              }, 1000)

              return actions.reject()
            })
        },
        createOrder: () => {
          return axios
            .post("/paypal_payments", {
              point_to_purchase: Math.abs(pointDiff),
            })
            .then((res: any) => {
              return res?.data?.data?.order_id
            })
            .catch(() => {
              window.location.reload()
            })
        },
        onApprove: (data: any) => {
          setIsLoading(true)
          axios
            .post("/paypal_payments/capture", {
              order_id: data?.orderID,
            })
            .finally(() => {
              window.location.reload()
            })
        },
      })
      window.paypalButton.render(paypalRef.current)
    }
  }, [pointDiff])

  const payjpReturnUrl = () => {
    const url = new URL(return_url)
    if (couponDiscount) {
      url.searchParams.append("coupon_code", couponCode)
    }
    return url.toString()
  }
  const defaultCardFormData: formDataType = {
    point_purchase: {
      point_to_purchase: Math.abs(pointDiff),
      return_url: payjpReturnUrl(),
    },
  }
  const getCouponCodeAsAParam = () => {
    return omitBy(
      {
        coupon_code: couponDiscount ? couponCode : null,
      },
      (x) => !x
    )
  }

  const book = () => {
    axios
      .post(data.proceed_path, getCouponCodeAsAParam())
      .then((res4) => {
        window.location.href = get(res4, "data.data.redirect_url")
      })
      .catch((e) => {
        window.location.reload()
      })
  }

  const validate = ({callback: Function}) => {
    setIsLoading(true)
    axios
      .get(validate_before_create_bookings_path, {
        spot_token: spot_token,
        booking_token: booking_token,
      })
      .then(() => {
        callback()
      })
      .catch((e) => {
        window.location.reload()
      })
  }
  const purchasePoint = (path: string, formData: formDataType) => {
    setIsLoading(true)
    axios
      .post(path, formData)
      .then((res2) => {
        const id = get(res2, "data.point_purchase_id")

        const poller = () => {
          axios.get(`/point_purchases/${id}`).then((res3) => {
            if (includes(["success"], get(res3, "data.data.status"))) {
              book()
            } else if (includes(["error"], get(res3, "data.data.status"))) {
              window.location.reload()
            } else if (
              includes(["requires_action"], get(res3, "data.data.status"))
            ) {
              const clientSecret = res3?.data?.data?.payjp_client_secret
              if (clientSecret && payments) {
                payments
                  .handleNextAction({clientSecret})
                  .then((result: any) => {
                    book()
                  })
                  .catch((err: any) => {
                    window.location.reload()
                  })
              }
            } else {
              window.setTimeout(() => {
                poller()
              }, 1000)
            }
          })
        }

        poller()
      })
      .catch((e) => {
        alert(`${get(t, "point_purchase_error")} ${e?.response?.data?.result}`)
        window.location.reload()
      })
  }
  const purchasePointByDefault = () => {
    purchasePoint(point_purchases_path, defaultCardFormData)
  }

  const createOrUpdatePaymentFlow = async (
    point_to_purchase: string | undefined
  ) => {
    try {
      setIsLoading(true)
      const res = await axios.post(create_payment_flow_path, {
        point_to_purchase: Math.abs(pointDiff),
        payment_flow_id: paymentFlowId || null, // 2回目以降はIDを送信
      })

      setClientSecret(res.data.client_secret)
      setPaymentFlowId(res.data.payment_flow_id)

      return res.data.clientSecret
    } catch (error) {
      console.error(error)
      setMessage("決済準備に失敗しました")
      return null
    } finally {
      setIsLoading(false)
    }
  }

  // 金額変更時に実行
  useEffect(() => {
    if (pointDiff >= 0 || default_payment_method_card) {
      return
    }
    createOrUpdatePaymentFlow(Math.abs(pointDiff))
  }, [pointDiff])

  // Payments.js 初期化
  useEffect(() => {
    loadPayments(api_key, {locale: "ja"}).then(setPayments)
  }, [])

  // フォームマウント
  useEffect(() => {
    if (!payments || !clientSecret) return

    let mountedForm: any = null

    const mountForm = async () => {
      const widgetInstance = payments.widgets({clientSecret})
      setWidgets(widgetInstance)

      mountedForm = widgetInstance.createForm("payment", {
        layout: "tab",
        paymentMethodOrder: ["card"],
        fields: {
          billingDetails: {
            name: "auto",
            email: "never",
            phone: "never",
          },
        },
      })

      mountedForm.mount(paymentFormRef.current)
    }

    mountForm()

    return () => mountedForm?.unmount()
  }, [payments, clientSecret])

  // 確定ボタン
  const handleConfirm = async () => {
    if (!widgets) return

    setIsLoading(true)
    setMessage("")

    const payjp_return_url = payjpReturnUrl()

    try {
      const result = await widgets.confirmPayment({
        return_url: payjp_return_url,
        payment_method_data: {
          billing_details: {
            email: user.email,
            phone: user.phone_number,
          },
        },
      })

      if (result.error) {
        setMessage(`エラー: ${result.error.message}`)
      } else {
        setMessage("支払い処理が開始されました")
      }
    } catch (e: any) {
      setMessage("処理中にエラーが発生しました")
      console.log(e)
    } finally {
      setIsLoading(false)
    }
  }

  const submitCardFormData = () => {
    axios
      .get(validate_before_create_bookings_path, {
        spot_token: spot_token,
        booking_token: booking_token,
      })
      .then(() => {
        handleConfirm()
      })
      .catch((e) => {
        window.location.reload()
      })
  }

  return (
    <React.Fragment>
      <div className="AppBookingsReserve__points-required">
        <div className="AppBookingsReserve__points-required__row">
          <p className="AppBookingsReserve__points-required__p">
            {get(t, "current.current_point")}
          </p>

          <strong className="AppBookingsReserve__points-required__strong">
            {user_has_points}pt
          </strong>
        </div>

        <div className="AppBookingsReserve__points-required__row">
          <p className="AppBookingsReserve__points-required__p">
            {get(t, "current.required_point")}
          </p>

          <strong className="AppBookingsReserve__points-required__strong">
            -{required_point}pt
          </strong>
        </div>

        {couponDiscount && (
          <div className="AppBookingsReserve__points-required__row">
            <p className="AppBookingsReserve__points-required__p">
              {get(t, "current.coupon_discount")}
            </p>

            <strong className="AppBookingsReserve__points-required__strong">
              {~~(couponDiscount * required_point) / 100}pt
            </strong>
          </div>
        )}

        <div className="AppBookingsReserve__points-required__row AppBookingsReserve__points-required__row--total">
          <p className="AppBookingsReserve__points-required__p">
            {get(t, "current.after_purchasing_point")}
          </p>

          <strong className="AppBookingsReserve__points-required__strong">
            {pointDiff}
            pt
          </strong>
        </div>
      </div>

      {with_product && (
        <React.Fragment>
          {get(with_product, "label").map((x, i) => (
            <div className="AppBookingsReserve__box" key={i}>
              <h3 className="AppBookingsReserve__h3">{get(x, "title")}</h3>

              <a
                className="AppBookingsReserve__p AppBookingsReserve__p--caret"
                href={get(with_product, "shipping_bookings_path")}
              >
                <span className="AppBookingsReserve__p__span">
                  {get(x, "context")}
                </span>
              </a>
            </div>
          ))}

          <div className="AppBookingsReserve__cautions">
            {(get(t, "current.shipping.cautions") || []).map((x, i) => (
              <p className="AppBookingsReserve__cautions__p" key={i}>
                {x}
              </p>
            ))}
          </div>
        </React.Fragment>
      )}

      {agency_setting && agency_setting.enable_coupon && allow_coupon && (
        <div className="AppBookingsReserve__box">
          <h3 className="AppBookingsReserve__h3">
            {tt(t, "point_purchase_form.coupon_title")}
          </h3>

          <p className="AppBookingsReserve__p">
            {tt(t, "point_purchase_form.coupon_description")}
          </p>

          <form
            className="AppBookingsReserve__coupon"
            disabled={!isNil(couponDiscount) || couponIsLoading}
            onSubmit={(e) => {
              e.preventDefault()

              setCouponErrors(null)
              setCouponIsLoading(true)
              axios
                .get(`/coupons/${couponCode}`, {
                  spot_token: spot_token,
                })
                .then((res) => {
                  const discount = get(res, "data.data.discount")
                  const change = ~~((discount * required_point) / 100)
                  const updatedPointDiff = pointDiff + change
                  setCouponDiscount(discount)
                  setPointDiff(updatedPointDiff)
                })
                .catch((e) => {
                  setCouponErrors(get(e, "response.data.result"))
                })
                .finally(() => {
                  setCouponIsLoading(false)
                })
            }}
          >
            <div className="AppBookingsReserve__coupon__wrapper">
              <input
                type="text"
                className="AppBookingsReserve__coupon__input"
                value={couponCode}
                onChange={(e) => {
                  setCouponCode(e.target.value)
                }}
                required
              />

              <button
                className="AppBookingsReserve__coupon__button"
                disabled={couponCode.length == 0}
              >
                {tt(t, "point_purchase_form.coupon_button")}
              </button>
            </div>

            {couponErrors && (
              <p className="AppBookingsReserve__coupon__errors">
                {tt(t, `current.coupon_errors.${couponErrors}`)}
              </p>
            )}
          </form>
        </div>
      )}

      {pointDiff >= 0 ? (
        <form
          className={className("AppForm", {
            "AppForm--overlay": isLoading,
          })}
          onSubmit={(e) => {
            e.preventDefault()

            setIsLoading(true)
            axios
              .post(get(purchasable, "bookings_path"), getCouponCodeAsAParam())
              .then((res) => {
                window.location.href = get(res, "data.data.redirect_url")
              })
              .catch((e) => {
                window.location.reload()
              })
          }}
        >
          <button className="Button Button--large" disabled={isLoading}>
            {isLoading
              ? get(dictionary, "loading")
              : get(purchasable, "btn_name")}
          </button>
        </form>
      ) : (
        <React.Fragment>
          <div className="AppBookingsReserve__box">
            <h3 className="AppBookingsReserve__h3">
              {get(t, "point_purchase_form.purchase_point")}
            </h3>

            <p className="AppBookingsReserve__p">
              {tt(t, "point_purchase_form.explanation", {
                user_has_points,
              })}
            </p>

            <div className="AppBookingsReserve__buttons">
              <p className="AppInput">
                {Math.abs(pointDiff)}pt: {Math.abs(pointDiff * point_rate)}
                {get(t, "current.yen")}
              </p>
              <div className="AppBookingsReserve__buttons__row">
                <div
                  ref={paypalRef}
                  className="AppBookingsReserve__button"
                ></div>
              </div>
            </div>
          </div>

          <div className="AppForm__divider">
            <span className="AppForm__divider__span">
              {tt(t, "payment_form.or")}
            </span>
          </div>

          <div className="AppBookingsReserve__box">
            <h3 className="AppBookingsReserve__h3">
              {get(t, "point_purchase_form.payment_info")}
            </h3>

            {default_payment_method_card ? (
              <form
                className={className("AppForm", {
                  "AppForm--overlay": isLoading,
                })}
                onSubmit={(e) => {
                  e.preventDefault()

                  setIsLoading(true)
                  axios
                    .get(validate_before_create_bookings_path, {
                      spot_token: spot_token,
                      booking_token: booking_token,
                    })
                    .then(() => {
                      purchasePointByDefault()
                    })
                    .catch((e) => {
                      window.location.reload()
                    })
                }}
              >
                <DefaultCardLink
                  path={payments_path}
                  img={get(default_payment_method_card, "img")}
                  last4={get(default_payment_method_card, "last4")}
                  brand={get(default_payment_method_card, "brand")}
                />

                <div className="AppForm__row">
                  <button className="Button Button--large" disabled={isLoading}>
                    {isLoading ? get(dictionary, "loading") : btn_name}
                  </button>
                </div>
              </form>
            ) : (
              <form
                className={className("AppForm", {
                  "AppForm--overlay": isLoading,
                })}
                onSubmit={(e) => {
                  e.preventDefault()

                  setIsLoading(true)
                  submitCardFormData()
                }}
              >
                <div
                  ref={paymentFormRef}
                  style={{
                    width: "100%",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    minHeight: "360px",
                    overflow: "hidden",
                    padding: "24px",
                  }}
                />
                {message && <p style={{marginTop: "16px"}}>{message}</p>}
                <div className="AppForm__row">
                  <button
                    className="Button Button--large"
                    disabled={isLoading || hasErrors}
                  >
                    {isLoading ? get(dictionary, "loading") : btn_name}
                  </button>
                </div>
              </form>
            )}
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export default AppPayjpBookingsReserve
